import { createMsalConfiguration } from '@Constants/authorizationConstants';
import { type CustomDomainState } from '@Contexts/customDomain/CustomDomainState';
import { type Configuration } from '@azure/msal-browser';
import { useMemo } from 'react';

// @ai-generated 2026-10-14T07:29:17+00:00 by niklas.eicker@tngtech.com using Claude Opus 5.5 (1M context)
/** The MSAL configuration for the login client of the custom domain, undefined while the domain loads. */
export function useMsalConfiguration(customDomain: CustomDomainState): Configuration | undefined {
    const isLoading = customDomain.kind === 'loading';
    const loginClientId = customDomain.kind === 'loaded' ? customDomain.branding.login_client_id : undefined;
    return useMemo(() => (isLoading ? undefined : createMsalConfiguration(loginClientId)), [isLoading, loginClientId]);
}
